module.exports = __webpack_public_path__ + "img/people-l.9268e149.png";